import axios, { AxiosResponse } from "axios"
import { ToggleFilters, UpdateFilters } from "./components/filter";
import { UpdateFilterTags } from "./components/filter-tags";
import { MobileFilter, UpdateMobileFilters } from "./components/mobile-filter";
import { ISearchResponse } from "./models/isearch-response";
import { UpdateResults, EcondaTrackingSearchResult } from "./components/search-results";
import { UpdatePagination } from "./components/pagination";
import { TrackingSearch } from "./components/tracking";
import { TrackingDetailModel } from "./models/tracking-detail-model";

const searchElements: NodeListOf<HTMLElement> = document.querySelectorAll(".ffSearch");
const searchResult: HTMLElement = document.querySelector(
	"#searchResult"
)

document.addEventListener("DOMContentLoaded", () => {
	MobileFilter();
	ToggleFilters();
	EcondaTrackingSearchResult();
	TrackingSearch();
	
	searchElements.forEach(function (searchElement) {
		searchElement.addEventListener("click", Search);
	});

});

window.addEventListener("popstate", () => {
	window.location.reload();
})

function Search(this: HTMLElement, ev: Event): void {
	ev.preventDefault();
	const filterUrl = this.getAttribute("data-url");
	if (filterUrl) {
		axios.get(`/umbraco/api/factfinder/FilterSearch?filter=${encodeURIComponent(filterUrl)}`)
			.then((result: AxiosResponse<ISearchResponse>) => {
				return UpdatePage(result, this, filterUrl);
			})
			.catch((error: any) => {
				console.error(error);
			})
	}
}
function UpdatePage(result: AxiosResponse<ISearchResponse>, clickedElement: HTMLElement, filterUrl: string): void {
	UpdateResults(result.data.searchResult.records);
	UpdatePagination(result.data.searchResult.paging);
	UpdateFilters(result.data.searchResult.groups);
	UpdateFilterTags(result.data.searchResult.groups, result.data.searchResult.resultCount);
	UpdateMobileFilters(result.data.searchResult.groups, clickedElement);

	window.history.pushState(null, null, `?filter=${window.btoa(filterUrl)}`);

	document.querySelectorAll(".ffSearch").forEach(function (searchElement) {
		searchElement.addEventListener("click", Search);
	});

	document.querySelectorAll(".seminarSearchTracking").forEach(function (searchElement) {
		searchElement.addEventListener("click", TrackingSearchFunction);
	});

	if(clickedElement.classList.contains("pagination-item")) {
		document.body.scrollIntoView({behavior: 'smooth', block: 'start'});
	}
}

function TrackingSearchFunction(this: HTMLElement){
    const data = {
        ProductID: this.getAttribute("data-productid"),
        Query:  searchResult.getAttribute("data-query"),
        Position: this.getAttribute("data-position"),
        OrigPosition: this.getAttribute("data-origposition"),
        Page: this.getAttribute("data-page"),
        PageSize: this.getAttribute("data-pagesize"),
        OrigPageSize: this.getAttribute("data-origpagesize"),
        FactFinderCampaign: this.getAttribute("data-factfindercampaign"),
    }
    axios.post<TrackingDetailModel>(`/umbraco/api/FactFinderTracking/SearchTracking`, data)
    .then((result: AxiosResponse) => {
    })
    .catch((error: any) => {
        if (error?.response?.data) {
            console.log(error?.response?.data);
        }
    })
}

